/*
 *    Check if something is an array with at least 1 element
 */
export const isArrayWithContent = (data: unknown): data is any[] =>
    !!data && Array.isArray(data) && data.length !== 0;
